var parseFloat = require('../internals/parse-float'); // `Number.parseFloat` method
// https://tc39.github.io/ecma262/#sec-number.parseFloat


require('../internals/export')({
  target: 'Number',
  stat: true,
  forced: Number.parseFloat != parseFloat
}, {
  parseFloat: parseFloat
});